<script>
import Layout from '@/Shared/Layout'
export default { layout: Layout }
</script>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue'
import { Head, Link } from '@inertiajs/inertia-vue3'
import Pagination from '@/Shared/Pagination'
import Newscard from '@/Pages/News/Newscard'
import Filter from '@/Shared/Filter/Filter'
import usePref from '@/Shared/usePref.js'
import useIsotope from '@/Shared/useIsotope.js'
import ButtonRounded from '@/Shared/Buttons/ButtonRounded'

const props = defineProps({
  newsItems: Object,
  category: String,
  brands: String,
  stores: String,
  pref: Object,
})

const containerRef = ref()
const filterRef = ref()

const openFilter = () => {
  filterRef.value.toggleOpen()
}

onMounted(() => {
  usePref(props.pref)
  useIsotope({
    isotopeContainer: containerRef.value,
    isotopeItem: '.isotope-item',
    data: props.newsItems.data,
    key: 'newsThumb',
  })
})

onUnmounted(() => {})
</script>

<template>
  <div class="news-list">
    <Head title="ニュース一覧" />

    <div class="bg-white min-h-[100dvh]">
      <h2 class="page-title">NEWS<small> ニュース </small></h2>

      <div class="relative z-10 font-rift font-bold mt-[-10px] xl:mt-[-20px] text-[18px] xs:text-[20px] sm:text-[24px] lg:text-[26px] pb-[35px] sm:pb-[70px] text-black text-center flex items-center justify-center">
        <Link href="/news/all" :class="{ 'text-afgreen': props.category === 'all' }" preserve-scroll>ALL</Link>
        <span class="inline-block h-[12px] sm:h-[16px] lg:h-[20px] w-px bg-[#999] mx-[15px] sm:mx-[20px]" />
        <Link href="/news/release" :class="{ 'text-afgreen': props.category === 'release' }" preserve-scroll>RELEASE</Link>
        <span class="inline-block h-[12px] sm:h-[16px] lg:h-[20px] w-px bg-[#999] mx-[15px] sm:mx-[20px]" />
        <Link href="/news/event" :class="{ 'text-afgreen': props.category === 'event' }" preserve-scroll>EVENT</Link>
        <span class="inline-block h-[12px] sm:h-[16px] lg:h-[20px] w-px bg-[#999] mx-[15px] sm:mx-[20px]" />
        <Link href="/news/store" :class="{ 'text-afgreen': props.category === 'store' }" preserve-scroll>STORE</Link>
      </div>

      <template v-if="newsItems.data.length">
        <div class="mb-[50px] sm:mb-[80px] mt-[-10px] sm:mt-[-30px] px-[calc(5vw_+_10px)] xs:px-[40px] sm:px-[60px] max-w-[600px] md:max-w-[900px] lg:max-w-[1100px] 3xl:max-w-[1500px] mx-auto">
          <div ref="containerRef" class="isotope-container m-[-2.5vw] xs:m-[-10px]">
            <div v-for="news in newsItems.data" :key="news.newsID" class="isotope-item hover-item w-1/2 md:w-1/3 lg:w-1/4 3xl:w-1/5 p-[2.5vw] xs:p-[15px]">
              <Newscard :info="news" />
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <p class="text-center pt-[80px] sm:pt-[100px] text-[110%] sm:text-[120%] mb-[40px] leading-[1.8]">この絞り込み条件に該当する<br class="sm:hidden" />ニュースはありません。</p>
        <ButtonRounded class="mx-auto max-w-[235px]" text="絞り込み条件を変更する" icon="arrow" @click="openFilter" />
      </template>

      <pagination class="!mt-[-30px]" :links="newsItems.links" />
    </div>
  </div>

  <teleport to="#app">
    <Filter ref="filterRef" />
  </teleport>
</template>
